import React from 'react';
import './CustomArrow.css';

const CustomArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', background: 'gray' }}
      onClick={onClick}
    />
  );
};

export default CustomArrow;
